// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_int32 from "../../../../../../node_modules/rescript/lib/es6/caml_int32.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";

function scrollToSlide(currentSlide, childrenCount) {
  var slideToIndex = currentSlide < (childrenCount - 1 | 0) ? currentSlide + 1 | 0 : 0;
  var scrollToProps_left = Math.imul(slideToIndex, 400);
  var scrollToProps = {
    behavior: "smooth",
    left: scrollToProps_left
  };
  var element = document.getElementById("carousel");
  element.scrollTo(scrollToProps);
}

function returnStartSetTimeoutId(autoplay, setCurrentSlide, childrenCount, currentSlide, is_mobile, delay) {
  if (autoplay) {
    return Caml_option.some(setTimeout((function (param) {
                      Curry._1(setCurrentSlide, (function (prev) {
                              return {
                                      current: Caml_int32.mod_(prev.current + 1 | 0, childrenCount)
                                    };
                            }));
                      if (is_mobile) {
                        scrollToSlide(currentSlide, childrenCount);
                        return ;
                      }
                      
                    }), delay));
  }
  
}

function stopTimer(autoplay, startTimer) {
  if (autoplay && startTimer !== undefined) {
    clearTimeout(Caml_option.valFromOption(startTimer));
    return ;
  }
  
}

function setSlide(current, is_mobile, childrenCount, setCurrentSlide) {
  if (is_mobile) {
    scrollToSlide(current - 1 | 0, childrenCount);
    return ;
  } else {
    return Curry._1(setCurrentSlide, (function (param) {
                  return current;
                }));
  }
}

function getTransformStyle(is_mobile, currentSlide) {
  if (is_mobile) {
    return "";
  } else {
    return "translateX(" + String(Math.imul(-currentSlide | 0, 100)) + "%)";
  }
}

function childrenWrapper(children, is_mobile, currentSlide, className) {
  return React.Children.map(children, (function (child, index) {
                return React.createElement("div", {
                            key: "carousel-item-" + String(index),
                            className: className,
                            style: {
                              transform: getTransformStyle(is_mobile, currentSlide)
                            }
                          }, child);
              }));
}

function getTouchCoordinate($$event) {
  return Caml_array.get($$event.changedTouches, 0).clientX;
}

function autoScroll(touchstartX, touchendX, setCurrentSlide, childrenCount) {
  if (touchendX > touchstartX) {
    return Curry._1(setCurrentSlide, (function (prev) {
                  if (prev.current === 0) {
                    return prev;
                  } else {
                    return {
                            current: prev.current - 1 | 0
                          };
                  }
                }));
  } else {
    return Curry._1(setCurrentSlide, (function (prev) {
                  if (prev.current === (childrenCount - 1 | 0)) {
                    return prev;
                  } else {
                    return {
                            current: prev.current + 1 | 0
                          };
                  }
                }));
  }
}

var scrollShiftPercentage = 100;

export {
  scrollShiftPercentage ,
  scrollToSlide ,
  returnStartSetTimeoutId ,
  stopTimer ,
  setSlide ,
  getTransformStyle ,
  childrenWrapper ,
  getTouchCoordinate ,
  autoScroll ,
}
/* react Not a pure module */
